import * as React from 'react'
import './question-card.scss'

export const QuestionCard = ({ title, description, className = '' }) => {
  const cardRef = React.useRef(null)
  const descriptionRef = React.useRef(null)

  const handleOpen = () => {
    toggleAnimation()
  }

  const toggleAnimation = async () => {
    let cardQuestionRef = cardRef.current

    if (!cardQuestionRef.classList.contains('active')) {
      let initialHeight = cardQuestionRef.clientHeight + 'px'
      cardQuestionRef.classList.add('active')

      //calc final height of card
      descriptionRef.current?.classList.add('active')
      cardQuestionRef.style.height = 'auto'
      let height = cardQuestionRef.clientHeight + 'px'

      //strart transition in the initial height
      cardQuestionRef.style.height = initialHeight

      setTimeout(function () {
        cardQuestionRef.style.height = height
        // cardRef.current.classList.add('active')
      }, 0)
    } else {
      descriptionRef.current?.classList.remove('active')
      let initialHeight = cardQuestionRef.clientHeight + 'px'

      //calc final height of card
      cardQuestionRef.style.height = 'fit-content'
      let totalHeight = cardQuestionRef.clientHeight + 'px'

      //strart transition in the initial height
      cardQuestionRef.style.height = initialHeight

      setTimeout(function () {
        cardQuestionRef.style.height = totalHeight
        cardQuestionRef.addEventListener(
          'transitionend',
          () => {
            cardQuestionRef.classList.remove('active')
          },
          { once: true }
        )
      }, 0)
    }
  }

  return (
    <div className={`f-question-card ${className}`} ref={cardRef}>
      <h3
        className="f-question-card__title"
        aria-label="open list"
        rol="button"
        aria-hidden="true"
        onClick={handleOpen}
      >
        {title}
      </h3>

      <p className="f-question-card__description" ref={descriptionRef}>
        {description}
      </p>

      <div className="f-question-card__button-container">
        <button
          className="f-question-card__button-container__button"
          aria-label="open list"
          onClick={handleOpen}
        ></button>
      </div>
    </div>
  )
}
